<template>
  <div class="big mydialog">
    <div class="page_title flex_between">
      <span>设置医生</span>
      <el-button type="primary" size="medium" style="width: 92px" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div style="display: flex;align-items: center;">
          <el-link
            style="margin:0 10px 0 30px"
            type="primary"
            @click="openDoctorList"
            >已选医生：{{ doctorTableData.length }}人</el-link
          >
          <el-button type="text" @click="removeDoctor">清除</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="adddialog"
            >添加医生</el-button
          >
          <el-button type="primary" icon="el-icon-plus" @click="importDoctorBtn"
            >导入医生</el-button
          >
        </div>
        <div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 8, maxRows: 10 }"
            placeholder="请填写公告内容，公告将在医生主页展示给患者"
            v-model="content"
            maxlength="300"
            show-word-limit
            style="width:600px;margin:20px 0 20px"
          >
          </el-input>

          <div class="flex wrap">
            <div class="box" v-for="(item, index) in imgList" :key="index">
              <img :src="item.path" class="img" />
              <div class="shadow">
                <i class="el-icon-delete" @click.stop="delImg(index)"></i>
              </div>
            </div>
            <el-upload
              name="image"
              accept=".png,.jpeg,.jpg"
              :show-file-list="false"
              :http-request="uploadImg"
              action="enter_img"
              v-if="imgList.length < 9"
            >
              <div slot="trigger">
                <div class="uploadbtn">
                  <i
                    class="el-icon-plus"
                    style="font-size:30px;margin-bottom:20px"
                  ></i>
                  <div>添加图片</div>
                </div>
              </div>
            </el-upload>
          </div>
          <div>
            <span>
              同时通知患者
            </span>
            <el-radio-group v-model="is_send">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div style="width:600px;text-align:center;margin-top:30px">
          <el-button type="primary" @click="publish" style="width:120px"
            >发布</el-button
          >
        </div>
      </div>
    </div>
    <!-- 设置医生弹窗 -->
    <el-dialog
      title="选择医生"
      :visible.sync="adddoctor"
      width="740px"
      :close-on-click-modal="false"
      :before-close="closeDia"
    >
      <div>
        <div class="searchbox" style="padding-left:15px">
          <div class="item">
            <span class="itemtitle">医生姓名</span>
            <el-input
              v-model="doctor_name"
              size="medium"
              style="width: 120px"
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">手机号</span>
            <el-input
              v-model="doctor_phone"
              size="medium"
              style="width: 120px"
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">医院名称</span>
            <el-input
              v-model="hospital"
              size="medium"
              style="width: 120px;margin-right:10px"
              @change="search"
            ></el-input>
            <el-button type="primary" @click="search" size="medium"
              >查询</el-button
            >
          </div>
        </div>
        <div style="padding: 0 25px">
          <div style="border: solid 1px #c9cbd6">
            <el-table
              ref="multipleTable"
              :data="doctorData"
              tooltip-effect="dark"
              style="width: 100%"
              :header-cell-style="{ background: '#F5F5F5' }"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection"></el-table-column>
              <el-table-column label="医生姓名" prop="doctor_name" width="130">
              </el-table-column>
              <el-table-column
                prop="phone"
                label="手机号"
                width="150"
              ></el-table-column>
              <el-table-column prop="hospital" label="医院"></el-table-column>
            </el-table>
          </div>
        </div>
        <div>
          <el-pagination
            @size-change="doctorSizeChange"
            @current-change="doctorCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin: 10px 0 20px 0"
          ></el-pagination>
        </div>
      </div>
      <div style="padding-bottom: 20px">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="setDoctor" size="medium"
            >添加，并继续查询</el-button
          >
          <el-button plain @click="closeDia" size="medium">取消</el-button>
        </span>
      </div>
    </el-dialog>
    <!-- 导入医生弹框 -->
    <el-dialog
      title="导入"
      :visible.sync="importDoctorDia"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div style="padding: 20px;display: flex;">
        <div style="width: 100px;">医生手机号：</div>
        <el-input
          type="textarea"
          :rows="10"
          placeholder="请填写需要代发的医生手机号，多个用逗号隔开"
          v-model="doctor_phone_str"
        >
        </el-input>
      </div>
      <div class="prompt" style="text-align: center;">
        注：每次代发时医生数不可超过40人
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="importDoctorDia = false">取 消</el-button>
        <el-button type="primary" @click="confirmImportDoctor">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 已选医生列表 -->
    <el-dialog title="已选医生" :visible.sync="doctorTableDataDia">
      <div style="padding: 20px;">
        <el-table
          :data="doctorTableData"
          border
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column
            property="doctor_name"
            label="医生姓名"
          ></el-table-column>
          <el-table-column
            property="phone"
            label="医生手机号"
          ></el-table-column>
          <el-table-column
            property="hospital"
            label="医生所在医院"
            width="150"
          ></el-table-column>
          <el-table-column property="title" label="医生职称"></el-table-column>
          <el-table-column
            property="department_name"
            label="科室"
          ></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="text" @click="delDoctor(scope.$index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import _ from "lodash";
import { uploadImg } from "../../../service/common/constant";

export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      allDoctor: 0,
      tableData: [],
      content: "",
      is_send: 1,
      doctorData: [],
      adddoctor: false,
      selection: "",
      doctor_name: "",
      doctor_phone: "",
      hospital: "",
      imgList: [],
      importDoctorDia: false,
      doctor_phone_str: "",
      doctorTableDataDia: false,
      doctorTableData: [],
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //添加医生弹窗
    adddialog() {
      this.currentPage = 1;
      this.pagesize = 10;
      this.doctor_name = "";
      this.doctor_phone = "";
      this.hospital = "";
      this.adddoctor = true;
      this.getDoctorList();
    },
    //查询医生
    getDoctorList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        hospital: this.hospital,
        auth_status: 2,
      };
      this.axios.post("platform/doctor/doctorList", data).then((res) => {
        if (res.code == 0) {
          this.doctorData = res.data.list;
          this.totalNum = res.data.total;
        }
      });
    },
    //多选
    handleSelectionChange(val) {
      this.selection = val;
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getDoctorList();
    },
    //选择医生每页数据的条数
    doctorSizeChange(size) {
      this.pagesize = size;
      this.getDoctorList();
    },
    //选择医生当前第几页
    doctorCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getDoctorList();
    },
    //设置医生
    setDoctor() {
      if (!this.selection.length) {
        this.$message.error("请先选择添加的医生");
        return false;
      }
      let arr = this.doctorTableData.concat(this.selection);
      this.doctorTableData = _.unionBy(arr, "doctor_id");
    },
    //关闭弹窗
    closeDia() {
      this.currentPage = 1;
      this.pagesize = 10;
      this.selection = "";
      this.adddoctor = false;
    },
    //移除医生
    removeDoctor() {
      this.doctorTableData = [];
    },
    //发布公告
    publish() {
      if (!this.doctorTableData.length) {
        this.$message.error("请先添加医生");
        return false;
      }
      if (!this.content && !this.imgList.length) {
        this.$message.error("请填写公告内容或者上传图片");
        return false;
      }
      let doctor_idArr = this.doctorTableData.map((item) => item.doctor_id);
      let data = {
        doctor_id: doctor_idArr.toString(),
        content: this.content,
        is_send: this.is_send,
      };
      if (this.imgList) {
        let images_arr = this.imgList.map((item) => {
          return item.pic;
        });
        data.images = images_arr.toString();
      }
      this.axios.post("platform/doctor/saveDoctorNotice", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("发布成功");
          this.back();
        }
      });
    },
    //上传图片
    uploadImg(params, item) {
      let file = params.file;
      uploadImg(file)
        .then((res) => {
          if (res.code == 0) {
            this.imgList.push(res.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //删除图片
    delImg(index) {
      this.$confirm("确定删除图片吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.imgList.splice(index, 1);
        })
        .catch(() => {});
    },
    back() {
      history.back();
    },
    // 查看已选医生
    openDoctorList() {
      this.doctorTableDataDia = true;
    },
    // 删除已选医生
    delDoctor(index) {
      this.doctorTableData.splice(index, 1);
    },
    // 导入医生
    importDoctorBtn() {
      this.doctor_phone_str = "";
      this.importDoctorDia = true;
    },
    // 确认导入医生
    confirmImportDoctor() {
      if (!this.doctor_phone_str) {
        this.$message.error("请填写医生手机号");
        return;
      }
      let arr = this.doctor_phone_str.split(",");
      if (!arr.length) {
        this.$message.error("请填写医生手机号");
        return;
      }
      if (arr.length > 40) {
        this.$message.error("每次代发时医生数不可超过40人");
        return;
      }
      let params = {
        doctor_phone_str: this.doctor_phone_str,
        page: 1,
        pageNumber: 999999999,
      };
      this.axios.post("platform/doctor/doctorList", params).then((res) => {
        if (res.code == 0) {
          let arr = this.doctorTableData.concat(res.data.list);
          this.doctorTableData = _.unionBy(arr, "doctor_id");
          this.importDoctorDia = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  .item {
    margin-right: 5px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    .itemtitle {
      margin-left: 10px;
      display: inline-block;
      text-align: right;
      margin-right: 5px;
    }
  }
}
.box {
  position: relative;
  box-sizing: border-box;
  margin-right: 20px;
  margin-bottom: 20px;
  &:hover .shadow {
    display: block;
  }
  .img {
    width: 160px;
    height: 160px;
  }
  .shadow {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    width: 160px;
    height: 160px;
    background-color: rgba(0, 0, 0, 0.6);
    display: none;
    line-height: 160px;
    text-align: center;
  }
  i {
    color: #ffffff;
    font-size: 30px;
    color: #d44747;
    cursor: pointer;
  }
}
.uploadbtn {
  color: #999;
  border: 1px solid #dedede;
  width: 160px;
  height: 160px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
